import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {startWith, switchMap, tap} from "rxjs/operators";
import {UserService} from "../../../../@shared/services/user.service";
import {MatDialog} from "@angular/material/dialog";
import {DetailsComponent} from "./modals/details/details.component";

export interface IInventoryLog {
  agentKey: string,
  amount: number,
  createdAt: string,
  data: { count: number, caseId: number, caseRevisionId: number, caseRevisionResultIds: number[] }
  id: number
  items: IInventoryItem[],
  transactionId: number,
  type: string,
  userId: number
}

export interface IInventoryItem {
  id: number,
  name: string,
  price: number
}

interface IGameType {
  name: string,
  value: string,
  selected: boolean
}

@Component({
  selector: 'app-inventory-log',
  templateUrl: './inventory-log.component.html',
  styleUrls: ['./inventory-log.component.scss']
})
export class InventoryLogComponent implements OnInit {
  inventoryLogColumns: string[] = ['date', 'type', 'items', 'amount', 'detail'];
  inventoryLogData: MatTableDataSource<IInventoryLog> = new MatTableDataSource<IInventoryLog>();

  public filterForm: UntypedFormGroup;
  public selectedFilters: UntypedFormControl = new UntypedFormControl();
  public searchText: UntypedFormControl = new UntypedFormControl('');
  public gameType: IGameType[] = [
    {
      name: "Deposit items",
      value: "payment",
      selected: false
    },
    {
      name: "Referral",
      value: "referral",
      selected: false
    },
    {
      name: "Double",
      value: "inventory-log",
      selected: false
    },
    {
      name: "Cases",
      value: "cases",
      selected: false
    },
    {
      name: "Upgrade",
      value: "upgrade",
      selected: false
    },
  ]
  public isLoading: boolean = true;

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;

  constructor(private userService: UserService,
              private fb: UntypedFormBuilder,
              private readonly dialog: MatDialog) {
    this.filterForm = this.fb.group({
        limit: new UntypedFormControl('500'),
        filter_key: new UntypedFormControl([])
      }
    )
  }

  ngOnInit() {
    this.filterForm.valueChanges.pipe(
      startWith(''),
      tap(() => {
        this.isLoading = true;
        this.inventoryLogData = new MatTableDataSource<IInventoryLog>();
      }),
      switchMap(() => {
        return this.userService.getInventoryOperations(this.filterForm.value);
      })
    ).subscribe(data => {
      this.inventoryLogData = new MatTableDataSource(data);
      this.inventoryLogData.paginator = this.paginator;
      this.inventoryLogData.sort = this.sort;
      this.isLoading = false;
    }, error => this.isLoading = true);
  }

  public openLogDetail(details: any): void {
    const params = {
      width: 'fit-content',
      height: 'fit-content',
      data: details
    }
    this.dialog.open(DetailsComponent, params)
  }

  selectedValue(matSelect: any): void {
    this.filterForm.patchValue({filter_key: this.selectedFilters.value.flat()});
    matSelect.close();
  }
}
